module.exports = __webpack_public_path__ + "media/images/hr/no-report-data-5f3fea10fb7c8b0c798706e82724267f.png";